<div class="name">
    <h4 class="title">{{ product.name }}</h4>&nbsp;
    <ng-container *ngIf="stars">
        <i class="travel-icon icon-star" aria-hidden="true" *ngFor="let Star of stars | numberToArr; let Si = index"></i>
    </ng-container>
</div>
<div class="address">
    <small>{{ product.address }}</small>
</div>
